module.exports = __webpack_public_path__ + "menu_0_active.222f5755.png";